
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((116|215|734)0|6222)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
